import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const TargetDefaultSvg = ({ size = 24 }) => (
  <SvgWrapper size={size}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H23.936V23.936H0z" />
      <path
        stroke="#D7E0EE"
        strokeWidth="2.992"
        d="M18.696 5.297c-1.717-1.732-4.097-2.804-6.728-2.804-5.233 0-9.475 4.242-9.475 9.475s4.242 9.475 9.475 9.475h0c5.233 0 9.475-4.242 9.475-9.475 0-1.849-.53-3.574-1.446-5.033"
      />
      <path
        stroke="#D7E0EE"
        strokeWidth="1.995"
        d="M15.485 8.611c-.885-.927-2.134-1.505-3.517-1.505-2.685 0-4.862 2.177-4.862 4.862s2.177 4.862 4.862 4.862h0c2.685 0 4.862-2.177 4.862-4.862 0-.494-.073-.97-.21-1.42"
      />
      <circle cx="11.968" cy="11.968" r="1.714" fill="#D7E0EE" />
      <path
        stroke="#D7E0EE"
        strokeWidth="1.496"
        d="M11.469 12.538L20.33 3.677"
      />
      <path
        stroke="#D7E0EE"
        strokeWidth="1.995"
        d="M20.248 1.301L20.248 3.989 22.79 3.989"
      />
    </g>
  </SvgWrapper>
)
